import { OpfsStorage } from "../caching/storage/OpfsStorage";
import { fileCacheWorker } from "@/workers";

const fileSystemDirectoryHandle = await navigator.storage.getDirectory();
const opfsStorage = new OpfsStorage(fileSystemDirectoryHandle);

export async function getNRRDFiles(caseId: string) {
  const nrrdFiles: Array<File> = [];

  // fileSystemDirectoryHandle.values() needs "DOM.AsyncIterable" to be included
  // in typescript compilerOptions.lib. "DOM.AsyncIterable" is available from TypeScript 5.4
  for await (const handle of (fileSystemDirectoryHandle as any).values()) {
    if (!handle.name.includes(caseId) || !handle.name.endsWith("seg.nrrd")) {
      continue;
    }
    const raw = await opfsStorage.loadData(handle.name);
    if (raw === null) {
      continue;
    }

    nrrdFiles.push(new File([new Blob([raw])], handle.name));
  }

  return nrrdFiles;
}

export async function getContent(
  key: string,
  caseId: string,
  fetch: () => Promise<ArrayBuffer>,
) {
  const fileName = `${caseId}-${key.split("/").pop()}`;
  const contentOnDisk = await opfsStorage.loadData(fileName);
  if (contentOnDisk !== null) {
    return contentOnDisk;
  }

  const data = await fetch();

  fileCacheWorker.postMessage("WRITE_CACHE", {
    data,
    fileName,
    shouldFileBeRemoved: true,
  });
  return data;
}
